import { IconUser, IconStethoscope } from "../../../components/icons/IconsPaciente";

// Paso 1: el usuario elige el tipo de busqueda.
const PasoTipo = ({ onElegir }) => (
    <div className="wizard-paso">
        <h3 className="wizard-paso__titulo">¿Cómo querés buscar tu turno?</h3>
        <div className="wizard-opciones">
            <button type="button" className="wizard-opcion" onClick={() => onElegir("nombre")}>
                <IconUser />
                <span className="wizard-opcion__titulo">Búsqueda por nombre</span>
                <span className="wizard-opcion__desc">Buscá un médico por su nombre.</span>
            </button>
            <button type="button" className="wizard-opcion" onClick={() => onElegir("servicio")}>
                <IconStethoscope />
                <span className="wizard-opcion__titulo">Búsqueda por servicio</span>
                <span className="wizard-opcion__desc">Elegí una especialidad o práctica.</span>
            </button>
        </div>
    </div>
);

export default PasoTipo;
